// A resource and the version it was read at.
//
// Venues and settings screens carry an `ETag`, and an edit must send the one it read as `If-Match`
// (spec/08 §2.5): a stale one is `412` and nothing is written. The generated result is the body, so
// the ETag is taken from the response head with the client's `onResponse`.

import type { ResponseHead } from '@clavian/api-client';

export interface Versioned<T> {
  readonly data: T;
  readonly etag: string;
}

type OnResponse = (head: ResponseHead) => void;

/** Run `call`, handing it an `onResponse` that keeps the ETag, and return both. */
export async function versioned<T>(call: (onResponse: OnResponse) => Promise<T>): Promise<Versioned<T>> {
  let etag: string | null = null;
  const data = await call((head) => {
    etag = head.headers.get('etag');
  });
  if (etag === null) {
    // Every route this is used with declares the header; its absence is a server or proxy bug, and
    // without it no edit could be saved, so it is loud rather than a screen that cannot save.
    throw new Error('The response carried no ETag, so an edit could not say which version it changes.');
  }
  return { data, etag };
}
